// import logo from './logo.png'

export default [
    {
        id: 'basic',
        caption: '装机',
        softwares: [
            {
                id: 'qq',
                caption: 'QQ',
                loginFlag: true,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'http://im.qq.com/pcqq/',
                optionUrl: '',
            }, {
                id: 'shadowsocks',
                caption: 'Shadowsocks',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'https://github.com/shadowsocks/shadowsocks-windows',
                optionUrl: '',
            }, {
                id: 'chrome',
                caption: 'Google Chrome',
                loginFlag: true,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'http://www.google.cn/chrome/browser/desktop/index.html',
                standByDownloadUrl: 'https://www.google.com/chrome/browser/thankyou.html?standalone=1&platform=win&installdataindex=defaultbrowser',
                optionUrl: '',
            }, {
                id: 'winrar',
                caption: 'WinRAR',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'http://www.winrar.com.cn/download.htm',
                optionUrl: '',
            }, {
                id: 'wox',
                caption: 'Wox',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'http://www.wox.one/',
                optionUrl: '',
            }, {
                id: 'enpass',
                caption: 'Enpass',
                loginFlag: true,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'https://www.enpass.io/downloads/',
                optionUrl: '',
            }, 
        ],
        more: [
            {
                id: 'pinyin',
                caption: 'Google 拼音输入法',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: true,
                downloadUrl: 'http://dl.google.com/pinyin/v2/GooglePinyinInstaller.exe',
                optionUrl: '',
            }, {
                id: 'mse',
                caption: 'Microsoft Security Essentials',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'https://www.microsoft.com/zh-CN/download/details.aspx?id=5201',
                optionUrl: '',
            }, {
                id: 'player',
                caption: 'QQ 影音',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'http://player.qq.com/',
                optionUrl: '',
            }, {
                id: 'xunlei',
                caption: '迅雷极速版',
                loginFlag: true,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'cloud-disk',
                optionUrl: '',
            }, {
                id: 'pan',
                caption: '百度网盘',
                loginFlag: true,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'http://pan.baidu.com/download',
                optionUrl: '',
            }, {
                id: 'wps',
                caption: 'WPS Office',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'http://www.wps.cn/',
                optionUrl: '',
            }, {
                id: 'jijiuxiang',
                caption: '360 系统急救箱',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'http://www.360.cn/jijiuxiang/',
                optionUrl: '',
            }, {
                id: 'huifu',
                caption: '360 文件恢复',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'cloud-disk',
                optionUrl: '',
            }, {
                id: 'diskgenius',
                caption: 'DiskGenius',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'cloud-disk',
                optionUrl: '',
            },
        ]
    }, {
        id: 'tools',
        caption: '前端开发',
        softwares: [
            {
                id: 'git',
                caption: 'Git',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'https://git-scm.com/downloads/',
                optionUrl: '',
            }, {
                id: 'nvm',
                caption: 'NVM for Windows',
                loginFlag: false,
                configFlag: true,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'https://github.com/coreybutler/nvm-windows',
                optionUrl: '',
            }, {
                id: 'vscode',
                caption: 'Visual Studio Code',
                loginFlag: false,
                configFlag: true,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'https://code.visualstudio.com/Download',
                optionUrl: '',
            }, {
                id: 'github',
                caption: 'GitHub Desktop',
                loginFlag: true,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'https://desktop.github.com/',
                optionUrl: '',
            }, {
                id: 'svn',
                caption: 'TortoiseSVN',
                loginFlag: true,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'https://tortoisesvn.net/downloads.html',
                optionUrl: '',
            },
        ],
        more: [
            {
                id: 'sublime',
                caption: 'Sublime Text 3',
                loginFlag: false,
                configFlag: false,
                licenseFlag: true,
                downloadFlag: false,
                downloadUrl: 'http://www.sublimetext.com/3',
                optionUrl: '',
            }, {
                id: 'packagecontrol',
                caption: 'Package Control',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'https://packagecontrol.io/installation',
                optionUrl: '',
            }, {
                id: 'fiddler',
                caption: 'Fiddler',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'https://www.telerik.com/download/fiddler',
                optionUrl: '',
            },
        ]
    },
    {
        id: 'graphics',
        caption: '图形图像、视音频处理',
        softwares: [
            {
                id: 'ps',
                caption: 'Photoshop CS3',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'cloud-disk',
                optionUrl: '',
            },
        ],
        more: [
            {
                id: 'graphicsmagick',
                caption: 'GraphicsMagick',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'ftp://ftp.graphicsmagick.org/pub/GraphicsMagick/windows/',
                optionUrl: '',
            }, {
                id: 'mockups',
                caption: 'Balsamiq Mockups',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'https://balsamiq.com/download/',
                optionUrl: '',
            }, {
                id: 'ai',
                caption: 'Illustrator CS3',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'cloud-disk',
                optionUrl: '',
            }, {
                id: 'riot',
                caption: 'RIOT',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'http://luci.criosweb.ro/riot/',
                optionUrl: '',
            }, {
                id: 'formatfactory',
                caption: '格式工厂',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'http://www.pcfreetime.com/formatfactory/CN/index.html',
                optionUrl: '',
            }, {
                id: 'vidown',
                caption: '维棠',
                loginFlag: false,
                configFlag: false,
                licenseFlag: false,
                downloadFlag: false,
                downloadUrl: 'http://www.vidown.cn/',
                optionUrl: '',
            },
        ]
    },
    // {
    //     id: 'node',
    //     caption: 'Node.js 开发',
    //     softwares: [
    //         {
    //             id: 'mongodb',
    //             caption: 'MongoDB',
    //             loginFlag: false,
    //             configFlag: true,
    //             licenseFlag: false,
    //             downloadFlag: false,
    //             downloadUrl: 'https://www.mongodb.com/download-center',
    //             optionUrl: '',
    //         }, {
    //             id: 'robo',
    //             caption: 'Robo 3T',
    //             loginFlag: false,
    //             configFlag: false,
    //             licenseFlag: false,
    //             downloadFlag: false,
    //             downloadUrl: 'https://robomongo.org/download',
    //             optionUrl: '',
    //         },
    //     ],
    //     more: []
    // },
    // {
    //     id: 'mobile',
    //     caption: 'Mobile App 开发',
    //     softwares: [
    //         {
    //             id: 'jdk',
    //             caption: 'Java SE Development Kit',
    //             loginFlag: false,
    //             configFlag: false,
    //             licenseFlag: false,
    //             downloadFlag: false,
    //             downloadUrl: 'http://www.oracle.com/technetwork/java/javase/downloads/index.html',
    //             optionUrl: '',
    //         }, {
    //             id: 'python',
    //             caption: 'Python',
    //             loginFlag: false,
    //             configFlag: false,
    //             licenseFlag: false,
    //             downloadFlag: false,
    //             downloadUrl: 'https://www.python.org/downloads/',
    //             optionUrl: '',
    //         }, {
    //             id: 'androidstudio',
    //             caption: 'Android Studio',
    //             loginFlag: false,
    //             configFlag: true,
    //             licenseFlag: false,
    //             downloadFlag: false,
    //             downloadUrl: 'https://developer.android.com/studio/index.html',
    //             optionUrl: '',
    //         },
    //     ],
    //     more: []
    // }
]
